export default {
    filters: {
        formatNumber(number) {
            if (!number) return "-";
            number = Number(number).toFixed(2);
            return Number(number)
                .toLocaleString("ru")
                .replace(".", ",");
        }
    }
}